import DubrinkError from "./Error.js";
import { useReviver } from "@/helpers/useReviver.js";
import { getCsrfToken } from "@/helpers/csrf.js";
import { useAuthStateStore } from "@/stores/auth-state.store.js";

const reviver = useReviver();
let sessionExpiredHandler = null;

export const setSessionExpiredHandler = (handler) => {
  sessionExpiredHandler = handler;
};

export const useFetch = () => {
  return {
    request: async (method = "GET", url, payload, upload = false) => {
      const { VITE_API_URL: apiEndpoint } = import.meta.env;
      const fullUrl = apiEndpoint + url;
      const response = await fetch(fullUrl, {
        method: method,
        credentials: "include",
        headers: {
          "x-csrf-token": getCsrfToken(),
          ...(!upload && { "Content-Type": "application/json" }),
        },
        ...(method !== "GET" && !upload && { body: JSON.stringify(payload) }),
        ...(method === "POST" && upload && { body: payload }),
      });
      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text, reviver);
      } catch (e) {
        data = null;
      }
      if (!response.ok) {
        const error = new DubrinkError(data?.msg || "ERROR.UNKNOWN_ERROR", response.status, data?.details);
        if (data?.redirectTarget) {
          error.handled = true;
          window.location.assign(data.redirectTarget);
        }
        if (response.status === 401) {
          const authStateStore = useAuthStateStore();
          const redirectTo = `${window.location.pathname}${window.location.search}${window.location.hash}`;
          error.handled = true;
          authStateStore.markSessionExpired(redirectTo);
          sessionExpiredHandler?.(authStateStore.getSessionExpiredRoute());
        }
        throw error;
      }
      return data;
    },
    getSearchParams: (filter, limit, page) => {
      const params = [];
      if (filter) {
        params.push(`filter=${filter}`);
      }
      if (limit) {
        params.push(`limit=${limit}`);
      }
      if (page) {
        params.push(`page=${page}`);
      }
      return params.length ? `?${params.join("&")}` : "";
    },
  };
};
